import { withRouter, useLocation, useHistory } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import '../../fonts/fonts.css'
import { getSimuPlayersSaga } from '../SimuPlayers/saga'
import SideBar from '../SideBar/index'
import { connect, useSelector } from 'react-redux'
import { compose } from 'redux'
import injectSaga from '../../utils/injectSaga'
import Circle from '../../components/StatsCircle'
import statsLogo from '../../images/Stats.svg'
import PageHeader from '../../components/PageHeader'
import {
  Bg,
  MainLayout,
  MainContainer,
  StatsSelector,
  SelectorStatsContainer,
  DashboardContainer,
  TopMetricsGrid,
  MetricCard,
  MetricLabel,
  MetricValue,
  SkillSection,
  SkillSectionTitle,
  SkillList,
  SkillItem,
  SkillHeader,
  SkillName,
  Score,
  SkillProgressTrack,
  SkillProgressFill,
  StatsGridSection,
  StatCircleGrid,
  StatCard,
  StatLabel,
  Percent,
  CircleWrap
} from './styledComponents'
import axios from 'axios'
import Dashboard from '../../components/Dashboard'
import IOButtonSendData from '../../components/IOButton_SendData'
import InfoContainer from '../../components/SimuPlayer_InfoContainer'
import PasserelleReport from '../../components/PasserelleReport'


const getTrainingTitle = (training) => (
  typeof training === 'string' ? training : ((training && (training.title || training.name)) || '')
)

const TRAINING_OPTION_PREFIX = 'TRAINING_'

const formatReportDate = (date) => (date ? new Date(date).toLocaleDateString('fr-FR') : '')

const toReportData = ({ finalReport, moduleTitle, student, agency }) => ({
  moduleTitle,
  student,
  agency,
  date: formatReportDate(finalReport.reportDate),
  duration: '',
  skills: (finalReport.scores || []).map((score) => ({
    label: score.key,
    level: score.value
  })),
  synthesis: finalReport.summary || ''
})

const StatsSimu = () => {
  const location = useLocation()
  const history = useHistory()

  const agencytoken = useSelector((state) => state.toJS().global.agencytoken)
  const entity = useSelector((state) => state.toJS().global.entity || 'TGD')
  const agencyName = useSelector((state) => state.toJS().global.agencyName)

  const simuPlayers = useSelector((state) => state.toJS().global.simuPlayers)
  const id = location.query ? location.query.id : location.pathname.split('/')[3]
  const [refreshedPlayer, setRefreshedPlayer] = useState(null)
  const [circleSize, setCircleSize] = useState(80)
  const [nbSequence, setNbSequence] = useState(null)
  const [animateSkills, setAnimateSkills] = useState(false)
  const [statsAnimProgress, setStatsAnimProgress] = useState(0)
  const [selectedStats, setSelectedStats] = useState('TGD2')
  const [finalReports, setFinalReports] = useState([])
  const [finalReportsLoading, setFinalReportsLoading] = useState(false)
  const [finalReportsError, setFinalReportsError] = useState(null)

  const storePlayer = simuPlayers
    ? simuPlayers.find((p) => p.id === id || p._id === id || p.studentId === id) || {}
    : {}
  const player = refreshedPlayer || storePlayer
  const playerTrainings = player.availableTrainings || []

  const trainingOptions = playerTrainings
    .map((training, index) => ({
      value: `${TRAINING_OPTION_PREFIX}${index}`,
      label: getTrainingTitle(training)
    }))
    .filter((option) => option.label)

  const selectedTraining = trainingOptions.find((option) => option.value === selectedStats)

  const playerFullName = `${player.firstname || ''} ${player.lastname || ''}`.trim()

  const latestFinalReport = finalReports
    .slice()
    .sort((a, b) => new Date(b.reportDate || 0) - new Date(a.reportDate || 0))[0]

  const passerelleReport = latestFinalReport
    ? toReportData({
      finalReport: latestFinalReport,
      moduleTitle: (selectedTraining && selectedTraining.label) || '',
      student: playerFullName,
      agency: agencyName || ''
    })
    : null

  const getSequenceNumber = async () => {

   const nb = await axios.get(`${process.env.REACT_APP_TGDAPI_SERVER}/sequences/count`, {headers: {Authorization: `Bearer ${agencytoken}`}})
   .catch(e => {
    console.log(e.message)
    setNbSequence(null)
   })
     if (nb && typeof nb.data === 'number') {
    setNbSequence(nb.data)
     }
  }

  const getFinalReports = async () => {
    setFinalReportsLoading(true)
    setFinalReportsError(null)
    const reports = await axios.get(`${process.env.REACT_APP_TGDAPI_SERVER}/finalreports?studentId=${id}`, {headers: {Authorization: `Bearer ${agencytoken}`}})
    .catch(e => {
      console.log(e.message)
      setFinalReportsError(e.message)
    })
    setFinalReports(reports && Array.isArray(reports.data) ? reports.data : [])
    setFinalReportsLoading(false)
  }

  const getStudentById = async () => {
    const student = await axios.get(`${process.env.REACT_APP_TGDAPI_SERVER}/students/${id}`, {headers: {Authorization: `Bearer ${agencytoken}`}})
    .catch(e => {
     console.log(e.message)
    })
    if (student && student.data) {
      setRefreshedPlayer(student.data)
    }
   }

  useEffect(() => {
    getSequenceNumber()
    if (location?.state?.type === 'refresh') {
      getStudentById()
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (id && agencytoken) {
      getFinalReports()
    }
    // eslint-disable-next-line
  }, [id, agencytoken])

  useEffect(() => {
    window.addEventListener('resize', ResizeCircle)
    return () => {
      window.removeEventListener('resize', ResizeCircle)
    }
    // eslint-disable-next-line
  }, [])

  const ResizeCircle = () => {
    setCircleSize(window.innerWidth / 17)
  }

  useEffect(() => {
    setAnimateSkills(false)
    setStatsAnimProgress(0)
    setSelectedStats('TGD2')
  }, [id])

  // la formation selectionnee peut disparaitre quand les donnees de l'eleve se rafraichissent
  useEffect(() => {
    if (selectedStats.startsWith(TRAINING_OPTION_PREFIX) && !selectedTraining) {
      setSelectedStats('TGD2')
    }
    // eslint-disable-next-line
  }, [selectedStats, Boolean(selectedTraining)])


  const getTime = (time) => {
    if (time) {
      const h = parseInt(time / 60 / 60)
      const m = parseInt((time / 60) % 60)

      return h + 'h ' + m + 'm'
    }
    return 'Never played'
  }

  const formatDuration = (timeInSeconds) => {
    const safe = Math.max(0, timeInSeconds || 0)
    const h = parseInt(safe / 60 / 60)
    const m = parseInt((safe / 60) % 60)
    return h + 'h ' + m + 'm'
  }

  const formatScoreValue = (value) => {
    const rounded = Math.round((value || 0) * 10) / 10
    return Number.isInteger(rounded) ? rounded : rounded.toFixed(1)
  }

  const handleChangeStats = (event) => {
    if (event.value === 'TGD1') {
      history.push(`/simuplayers/stats/${id}`)
      return
    }
    setSelectedStats(event.value)
  }

  const displayStatsSelector = () => {
    const statsValues = [
      { value: 'TGD1', label: 'TGD1' },
      { value: 'TGD2', label: 'TGD2' }
    ]

    statsValues.push(...trainingOptions)
    return (
      <StatsSelector
        classNamePrefix='react-select'
        multiple={false}
        isSearchable={false}
        value={statsValues.find((option) => option.value === selectedStats) || statsValues[1]}
        onChange={(e) => handleChangeStats(e)}
        options={statsValues}
      />
    )
}

  const b2vmStats = {
    position: (player.stats && player.stats.position !== -1 && player.stats.position > 1) ? parseFloat(player.stats.position.toFixed(1)) : 0,
    pace: (player.stats && player.stats.pace !== -1 && player.stats.pace > 1) ? parseFloat(player.stats.pace.toFixed(1)) : 0,
    mirror: (player.stats && player.stats.mirror !== -1 && player.stats.mirror > 1) ? parseFloat(player.stats.mirror.toFixed(1)) : 0,
    sight: (player.stats && player.stats.sight !== -1 && player.stats.sight > 1) ? parseFloat(player.stats.sight.toFixed(1)) : 0,
    communication: (player.stats && player.stats.communication !== -1 && player.stats.communication > 1) ? parseFloat(player.stats.communication.toFixed(1)) : 0,
    eco: (player.stats && player.stats.eco !== -1 && player.stats.eco > 1) ? parseFloat(player.stats.eco.toFixed(1)) : 0
  }

  const competencies = [
    { key: 'competence1', label: 'Compétence 1', total: nbSequence },
    { key: 'competence2', label: 'Compétence 2', total: 7 },
    { key: 'competence3', label: 'Compétence 3', total: 10 },
    { key: 'competence4', label: 'Compétence 4', total: 7 }
  ]

  const scoreCards = [
    { label: 'Position', value: b2vmStats.position },
    { label: 'Allure', value: b2vmStats.pace },
    { label: 'Rétroviseurs', value: b2vmStats.mirror },
    { label: 'Regard', value: b2vmStats.sight },
    { label: 'Communication', value: b2vmStats.communication },
    { label: 'EcoConduite', value: b2vmStats.eco }
  ]

  const getScoreTone = (value) => {
    if (value >= 75) {
      return {
        start: '#f7faf8',
        end: '#f1f6f3',
        border: '#d5e2db',
        label: '#41564a',
        halo: '#eef4f0',
        badge: '#e6eee9'
      }
    }
    if (value >= 50) {
      return {
        start: '#f8f9fc',
        end: '#f2f4f8',
        border: '#d9dee8',
        label: '#3f4f67',
        halo: '#edf1f7',
        badge: '#e5eaf3'
      }
    }
    return {
      start: '#fbf8f6',
      end: '#f6f1ee',
      border: '#e3d9d1',
      label: '#6d594b',
      halo: '#f3ede8',
      badge: '#ece3dc'
    }
  }

  let isB2vm = player.stats || false
  const isSequenceCountReady = typeof nbSequence === 'number'

  useEffect(() => {
    const hasSkillData = Boolean(player.sequenceDoneCountDetail) && isSequenceCountReady
    if (!hasSkillData) return

    const timeout = setTimeout(() => {
      setAnimateSkills(true)
    }, 80)

    return () => clearTimeout(timeout)
  }, [
    id,
    isSequenceCountReady,
    player.sequenceDoneCountDetail?.competence1,
    player.sequenceDoneCountDetail?.competence2,
    player.sequenceDoneCountDetail?.competence3,
    player.sequenceDoneCountDetail?.competence4
  ])

  const doneCount = competencies.reduce((acc, item) => {
    const doneValue = player.sequenceDoneCountDetail && isB2vm ? (player.sequenceDoneCountDetail[item.key] || 0) : 0
    return acc + doneValue
  }, 0)
  const doneTotal = isSequenceCountReady ? nbSequence + 7 + 10 + 7 : null

  useEffect(() => {
    const hasData = Boolean(player?.stats || player?.sequenceDoneCountDetail || player?.playTime || player?.playDistance)
    if (!hasData) return

    let rafId
    let startTime
    const duration = 700

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp
      const elapsed = timestamp - startTime
      const progress = Math.min(1, elapsed / duration)
      setStatsAnimProgress(progress)

      if (progress < 1) {
        rafId = window.requestAnimationFrame(step)
      }
    }

    setStatsAnimProgress(0)
    rafId = window.requestAnimationFrame(step)

    return () => {
      if (rafId) window.cancelAnimationFrame(rafId)
    }
  }, [
    id,
    doneCount,
    doneTotal,
    player?.playTime,
    player?.playDistance,
    b2vmStats.position,
    b2vmStats.pace,
    b2vmStats.mirror,
    b2vmStats.sight,
    b2vmStats.communication,
    b2vmStats.eco
  ])

  const animatedDoneCount = Math.round(doneCount * statsAnimProgress)
  const animatedDoneTotal = doneTotal != null ? Math.round(doneTotal * statsAnimProgress) : null
  const targetPlayTime = player.playTime && isB2vm ? player.playTime : 0
  const animatedPlayTime = Math.round(targetPlayTime * statsAnimProgress)
  const targetDistanceKm = player.playDistance && isB2vm ? player.playDistance / 1000 : 0
  const animatedDistanceKm = targetDistanceKm * statsAnimProgress

    return (
      <Bg>
        <SideBar />
        <MainLayout>
          <PageHeader
            icon={statsLogo}
            title='Statistiques'
            subtitle={player && player.firstname ? `${player.firstname} ${player.lastname || ''}`.trim() : 'Suivi de progression'}
          />
          <MainContainer>
            <DashboardContainer>
              <Dashboard height={'48px'} type='infos' data={{firstName: player.firstname, lastName: player.lastname}}/>
              {entity === "IO" ?
                <div style={{position: 'absolute', right: '-60px', bottom: '0px'}}>
                  <IOButtonSendData
                    id={id}
                    accessToken={agencytoken}
                  />
                </div>
              : null}
            </DashboardContainer>
            <InfoContainer path={location.pathname} playerId={id} />
            <SelectorStatsContainer>
              {displayStatsSelector()}
            </SelectorStatsContainer>
            {selectedTraining ? (
              <PasserelleReport
                data={passerelleReport}
                loading={finalReportsLoading}
                error={finalReportsError}
              />
            ) : (
            <>
            <TopMetricsGrid>
              <MetricCard>
                <MetricLabel>Trajets validés</MetricLabel>
                <MetricValue>{animatedDoneCount} / {doneTotal != null ? doneTotal : '-'}</MetricValue>
              </MetricCard>
              <MetricCard>
                <MetricLabel>Temps écoulé</MetricLabel>
                <MetricValue>{formatDuration(animatedPlayTime)}</MetricValue>
              </MetricCard>
              <MetricCard>
                <MetricLabel>Kilomètres parcourus</MetricLabel>
                <MetricValue>{`${animatedDistanceKm.toFixed(1)} km`}</MetricValue>
              </MetricCard>
            </TopMetricsGrid>

            <SkillSection>
              <SkillSectionTitle>Progression des competences</SkillSectionTitle>
              <SkillList>
                {competencies.map((item) => {
                  const currentScore = player.sequenceDoneCountDetail && isB2vm
                    ? (player.sequenceDoneCountDetail[item.key] || 0)
                    : 0
                  const progressionPercent = item.total ? (currentScore * 100) / item.total : 0

                  return (
                    <SkillItem key={item.key}>
                      <SkillHeader>
                        <SkillName>{item.label}</SkillName>
                        <Score>{currentScore}/{item.total != null ? item.total : '-'}</Score>
                      </SkillHeader>
                      <SkillProgressTrack>
                        <SkillProgressFill style={{ width: animateSkills ? `${progressionPercent}%` : '0%' }} />
                      </SkillProgressTrack>
                    </SkillItem>
                  )
                })}
              </SkillList>
            </SkillSection>

            <StatsGridSection>
              <StatCircleGrid>
                {scoreCards.map((item) => {
                  const tone = getScoreTone(item.value || 0)
                  const animatedCircleValue = (item.value || 0) * statsAnimProgress
                  return (
                  <StatCard key={item.label} $toneStart={tone.start} $toneEnd={tone.end} $toneBorder={tone.border}>
                    <StatLabel $toneLabel={tone.label}>{item.label}</StatLabel>
                    <CircleWrap $toneHalo={tone.halo}>
                      <Circle size={circleSize} ratio={animatedCircleValue / 100} />
                      <Percent $toneBadge={tone.badge}>{formatScoreValue(animatedCircleValue)}</Percent>
                    </CircleWrap>
                  </StatCard>
                )})}
              </StatCircleGrid>
            </StatsGridSection>
            </>
            )}
          </MainContainer>
        </MainLayout>
      </Bg>
    )
}

const withLoader = injectSaga({ key: 'statsSimuB2vmLoader', saga: getSimuPlayersSaga })
const withConnect = connect(null, null)
const arg = compose(withLoader, withConnect)(StatsSimu)

export default withRouter(arg)
